import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableHead,
  Box,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useOperatorOffersByRefNumberQuery } from '@/api/queries/offers';
import { ModalBase, colors } from 'remote/global';
import { useTranslation } from 'react-i18next';

function PositionDetails({ refNumber }: { refNumber: string }) {
  const { data, isSuccess } = useOperatorOffersByRefNumberQuery(refNumber);
  const { t } = useTranslation();

  if (!isSuccess) return null;

  return (
    <Box
      sx={{
        padding: '0 1rem 1rem',
        '& .MuiTableRow-root:nth-of-type(odd)': { backgroundColor: colors.primaryBlue5 },
        '& .MuiTableRow-root .MuiTableCell-root:first-of-type': { fontWeight: 500 },
        '& .MuiTableCell-root': { borderBottom: 'none' },
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          width: '100%',
          borderRadius: '8px',
        }}
      >
        <Table>
          <TableHead>
            <TableRow
              sx={{
                '& > *:first-of-type': { paddingLeft: '16px' },
                '& > *:last-of-type': { paddingRight: '16px' },
                backgroundColor: 'transparent !important',
              }}
            >
              <TableCell
                sx={{
                  borderBottom: 'none',
                  color: colors.uiBlue600,
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  minWidth: 150,
                  backgroundColor: 'transparent',
                }}
              >
                {t(`modals.positionDetails.table.header.operatorName.label`)}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: 'none',
                  color: colors.uiBlue600,
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  minWidth: 150,
                }}
              >
                {t(`modals.positionDetails.table.header.priceInclVat.label`)}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: 'none',
                  color: colors.uiBlue600,
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  minWidth: 150,
                }}
              >
                {t(`PricingView.period.table.header.vehicleClass`)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(({ operatorName, priceInclVat, priceExclVat, vehicleClass }) => (
              <TableRow key={uuidv4()}>
                <TableCell>{operatorName}</TableCell>
                <TableCell>
                  {priceExclVat}/{priceInclVat} €
                </TableCell>
                <TableCell>{t(`VehicleClass.${vehicleClass}`)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

interface Props {
  open: boolean;
  bookingNumber: string;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function PositionDetailsModal({ open, onClose, bookingNumber, setOpen }: Props) {
  const { t } = useTranslation();

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      title={t('OffersView.title').toString()}
      maxWidth='md'
      fullWidth
    >
      <PositionDetails refNumber={bookingNumber} />
    </ModalBase>
  );
}

export default PositionDetailsModal;
